module.exports = __webpack_public_path__ + "static/media/Afrinovator ico-12.cc44619b.png";